import React, { useContext, useEffect } from 'react';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import { Toaster } from 'react-hot-toast';
import { NecttosContext } from '../../context/NecttosContext';
import Cookies from 'js-cookie';
import Button from '../../NecttosComp/Button/Button';
import { Table, Td, Th, Tr } from '../../NecttosComp/Table/Table';
import { useQuery } from 'react-query';
import Input2 from '../../NecttosComp/Input/Input2';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import moment from 'moment';
import Instruction from '../../Documentation/Instruction';

const getWorkedTime = async (userId, startTime, endDate) => {
	const instance = await getAxiosTokenInstance();
	const data = await instance.get('/activityMonitor/getWorks', {
		params: {
			userId: userId,
			startDate: startTime,
			endDate: endDate,
		},
	});
	return data;
};

function ActivityMonitoring({ onClose }) {
	const { collegeId, userId } = useContext(NecttosContext);
	const userToken = Cookies.get('userToken');
	const [startDate, setStartDate] = React.useState(new Date().toLocaleDateString());
	const [endDate, setEndDate] = React.useState(new Date().toLocaleDateString());
	const [data, setData] = React.useState(null);

	useEffect(() => {
		const fetchData = async () => {
			if (!startDate || !endDate) return;
			const response = await getWorkedTime(userId, startDate, endDate);
			const { data } = response;
			setData(data?.result);
		};
		fetchData();
	}, [startDate, endDate]);

	const handleClose = () => {
		if (onClose) {
			onClose();
		}
	};
	const handleOpenTacker = () => {
		let url = `necttos://timming.in/login?userToken=${userToken}&collegeId=${collegeId}&userId=${userId}`;
		window.open(url, '_blank');
	};
	const handleDownloadTacker = () => {
		let url = `https://drive.google.com/drive/folders/1JeSg6ffZ4BOF_HoATftLmyMD5wzD4eFn?usp=drive_link`;
		window.open(url, '_blank');
	};

	console.log(data);

	return (
		<Main title='Activity Monitor' width={'100%'} height={'100%'}>
			<Toaster />
			<Header>
				<div className='flex justify-between items-center w-full'>
					<div className=''>
						<Button type='doc' onClick={handleOpenTacker} className='text-white'>
							Open Tacker
						</Button>
						<Button type='submit' onClick={handleDownloadTacker} className='text-white'>
							Download Tacker
						</Button>
					</div>
					<Instruction keyId={'activityMonitoring'}/>
					<Button type='close' onClick={handleClose} className='text-red-500'>
						Close
					</Button>
				</div>
			</Header>
			<Body>
				<div className='flex justify-between items-center w-full'>
					<div className='flex items-center w-full'>
						<Input2 type='date' width='400px' className='w-[400px]' state={startDate} setState={setStartDate} fieldName='Start Date' />
						<Input2 type='date' width='400px' className='w-[400px]' state={endDate} setState={setEndDate} fieldName='Start Date' />
					</div>
					<div className='flex items-center'>
						<h1 className='text-2xl font-bold'>Total Worked Time: {moment.utc(data?.workedTime * 1000).format('HH:mm:ss')}</h1>
					</div>
					<div className='flex items-center'>
						<h1 className='text-2xl font-bold'>Total Idle Time: {moment.utc(data?.idleTime * 1000).format('HH:mm:ss')}</h1>
					</div>
					<div className='flex items-center'>
						<h1 className='text-2xl font-bold'>Percentage: {data?.percentage}</h1>
					</div>
				</div>
				<Table width='100%' height='100%' className='overflow-hidden' innerWidth={['10%', '40%', '30%', '10%', '10%']}>
					<Tr className='text-center'>
						<Th className='text-center'>Date</Th>
						<Th className='text-center'>File</Th>
						<Th className='text-center'>App</Th>
						<Th className='text-center'>Work Time</Th>
						<Th className='text-center'>Idle Time</Th>
					</Tr>
					{data &&
						data?.data?.map((item, index) => (
							<Tr key={index} className='text-center'>
								<Td>{item.date}</Td>
								<Td>{item.title}</Td>
								<Td>{item.appName}</Td>
								<Td>{moment.utc(item.workedTime * 1000).format('HH:mm:ss')}</Td>
								<Td>{moment.utc(item.idleTime * 1000).format('HH:mm:ss')}</Td>
							</Tr>
						))}
				</Table>
			</Body>
		</Main>
	);
}

export default ActivityMonitoring;
